import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	tryAgainButton: {
		id: 'polaris-common.controllers.unfurl.utils.retry.try-again-button',
		defaultMessage: 'Try again',
		description: 'Try again button placeholder',
	},
});
